module.exports = __webpack_public_path__ + "static/media/sliderimage6.9e577824.jpg";